import React, { useEffect, useState, useRef, Fragment } from 'react'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import properties from '../../config/environmentProperties';
import { MultiSelect } from 'primereact/multiselect';
import ExpensesReview from "./expenses-review";
import { Calendar } from 'primereact/calendar';
import { Menu } from 'primereact/menu';
import { Util, expenseApi } from '../../services';
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import RejectExpensePopup from "./expense-reject-popup";
import { Carousel } from 'primereact/carousel';
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { Fieldset } from "primereact/fieldset";
import { Timeline } from 'primereact/timeline';
import moment from "moment";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import ApproveExpensePopup from "./expense-approve-popup";

const FinanceExpenses = () => {
    const [viewEmpExpenses, setViewEmpExpenses] = useState(false);
    const [clickedViewUser, setClickedViewUser] = useState([]);
    const [viewEmpList, setViewEmpList] = useState([true]);
    const [expenseCategories, setExpenseCategories] = useState(null);
    const [selectCategory, setSelectedCategory] = useState(null);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [selectedFinanceApproval, setSelectedFinanceApproval] = useState([]);
    const [getAllFinanceRecords, setAllFinanceRecords] = useState([]);
    const [rejectRowData, setRejectRowData] = useState({});
    const [rejectDialog, setRejectDialog] = useState(false);
    const [financeEmployees, setFinanceEmployees] = useState(null);
    const [currentRowData, setCurrentRowData] = useState(null);
    const [visible, setVisible] = useState(false);
    const docPath = properties.currentEnvironment.docPath + 'expense-documents/';
    const [selectAll, setSelectAll] = useState(true)
    const [selectedApprovedFinance, setSelectedApprovedFinance] = useState([])
    const menu = useRef(null);
    const [selectedDateRange, setSelectedDateRange] = useState(null);
    const [updateClearanceDialog, setUpdateClearanceDialog] = useState(false);
    const [clearanceDate, setClearanceDate] = useState([]);
    const [filterDialog, setFilterDialog] = useState(false);
    const [financeVisibility, setFinanceVisibility] = useState(false);
    const currentDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dateInTimeZone = new Date(currentDate.toLocaleString('en-US', { timeZone: timeZone }));
    const [timeline, setTimeline] = useState(false);
    const [expenseActivityData, setExpenseActivityData] = useState([]);
    const [currentRow, setCurrentRow] = useState({});
    const [approveRowData, setApproveRowData] = useState({});
    const [approveDialog, setApproveDialog] = useState(false);
    const [isFilterActive, setIsFilterActive] = useState(false);
    const [filterClicked, setFilterClicked] = useState(false);
    const [buttonStatus, setButtonStatus] = useState(false);
    const [clickedExpenseCategory, setClickedExpenseCategory] = useState('');
    const [clearanceRowData, setClearanceRowData] = useState({});

    useEffect(() => {
        getExpenseCategories();
        getAllFinanceExpenseData();
    }, []);

    const getExpenseCategories = (param) => {
        expenseApi.getCategories(param).then((resp) => {
            try {
                setExpenseCategories(resp.data.data)
            }
            catch (error) {
            }
        })
    }

    const getAllFinanceExpenseData = () => {
        let param = {}
        setFinanceVisibility(true)
        expenseApi.getFinanceData(param).then((resp) => {
            try {
                const formattedFinanceEmployees = resp.data.data.map((user) => ({
                    id: user.id,
                    name: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                    fullName: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                }));

                setFinanceEmployees(formattedFinanceEmployees);
                setAllFinanceRecords(resp.data.data);
            }
            catch {
            }
        });
    }

    let events = [];
    expenseActivityData.map((e) => {
        return Util.expenseActivityData(e, events, clickedExpenseCategory)
    })

    const customizedMarker = (item) => {
        return (
            <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: item.color }}>
                <i className={item.icon}></i>
            </span>
        );
    };

    const customizedContent = (item) => {
        return Util.TimelineView(item, clickedExpenseCategory)
    };

    const viewClaimTimeline = (currentRow) => {
        setClickedExpenseCategory(currentRow.category);
        getExpenseActivitiesByClaim(currentRow.claimId)
        setTimeline(true);
    }

    const getExpenseActivitiesByClaim = (claimId) => {
        expenseApi.getClaimActivities(claimId).then((resp) => {
            setExpenseActivityData(resp.data.data)
        });
    }

    const myExpenseTimeline = () => {
        return (
            <>
                <Dialog header="Expense Claim TimeLine" maximizable visible={timeline} onHide={() => setTimeline(false)} style={{ overflow: 'hidden' }}>
                    <div className="flex-column" style={{ width: 500, overflow: 'hidden' }}>
                        <Timeline value={events} className="customized-timeline" marker={customizedMarker} content={customizedContent} />
                    </div>
                </Dialog>
            </>
        );
    };

    const statusBodyTemplate = (data) => {
        return (
            <span style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>
                {Util.fetchStatus(data.status, data.category)}
            </span>
        );
    };

    const clearanceRowsUpdate = (currentRow) => {
        setUpdateClearanceDialog(true);
        setClearanceRowData(currentRow)
    }

    const ReviewActionBodyTemplate = (rowData) => {
        const items = [
            { label: "REVIEW TIMELINE", icon: "pi pi-eye", command: (e) => { viewClaimTimeline(currentRow) } },
            currentRow.status === 4 && { label: "APPROVE", icon: "pi pi-check", command: (e) => { setApproveDialog(true); setApproveRowData(rowData); } },
            currentRow.status === 4 && { label: "REJECT", icon: "pi pi-times", command: () => { setRejectDialog(true); setRejectRowData(rowData); } },
            buttonStatus && currentRow.status === 6 && { label: "Update Clearance Date", icon: "pi pi-history", command: () => { clearanceRowsUpdate(currentRow) } }
        ].filter(Boolean);

        const showMenu = (event) => {
            menu.current.toggle(event);
        };
        return (
            <>
                <Menu style={{ width: "15rem" }}
                    model={items}
                    popup
                    ref={menu}
                />
                <Button
                    className="p-button-rounded p-button-text"
                    icon="pi pi-ellipsis-v"
                    onClick={(e) => {
                        setSelectAll(false)
                        setSelectedApprovedFinance(rowData)
                        setCurrentRow(rowData);
                        showMenu(e)
                    }}
                />
            </>
        );
    };

    const viewDoc = (rowData) => {
        return (
            <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary ml-2" aria-label="View" tooltip="View Details" tooltipOptions={{ position: "top" }} onClick={() => { setCurrentRowData(rowData); setVisible(true) }} />
        );
    };

    const renderCarouselContent = (rowData) => {
        return (
            <Carousel
                value={rowData?.docs}
                itemTemplate={yourCarouselItemTemplate}
                numVisible={1}
                numScroll={1}
                circular
            />
        );
    };

    const yourCarouselItemTemplate = (doc) => {
        return (
            <>
                <p>{doc.fileName}</p>
                <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
            </>
        )
    };

    const carouselPopup = () => {
        return (
            <Dialog header={'Documents'} visible={visible} modal style={{ width: '1200px', height: '900px' }} onHide={() => setVisible(false)}>
                {renderCarouselContent(currentRowData)}
            </Dialog>
        )
    }

    const SelectedCheckedFinanceExpenses = (e) => {
        let disabledRow = e.filter((financeRow) => financeRow.status === 6);
        setSaveDisabled(disabledRow.length === 0);
        setFinanceVisibility(disabledRow.length > 0);
        setSelectedFinanceApproval(e);

        if (!filterClicked) return;
        const filteredSelection = e.filter((row) => row.status === 6);
        setSelectedFinanceApproval(filteredSelection);
        setSaveDisabled(filteredSelection.length === 0);
        setFinanceVisibility(filteredSelection.length > 0);
    };

    const areButtonsEnabled = () => {
        const hasStatus4 = selectedFinanceApproval.some(row => row.status === 4);
        return hasStatus4;
    };

    const RejectExpenseDialog = () => {
        return (
            <Dialog className="pop-up-dialog-recall" header="Reject Expense" visible={rejectDialog} style={{ width: '380px' }} onHide={() => setRejectDialog(false)}>
                <RejectExpensePopup
                    updateRejectRow={(data) => rejectTeamFinanceRecords(data)}
                    rejectRow={rejectRowData}
                    onClose={(e) => {
                        setRejectDialog(false);
                    }}
                />
            </Dialog>
        );
    };

    const rejectTeamFinanceRecords = (data) => {
        let claimIds = selectAll ? selectedFinanceApproval.map((item) => item.claimId) : [selectedApprovedFinance.claimId];
        if (selectedApprovedFinance.status === 4 || selectedFinanceApproval.length >= 1) {
            try {
                const param = {
                    status: 7,
                    claimId: claimIds,
                    reason: data.reason,
                };
                expenseApi.updateDraftExpense(param).then(
                    (resp) => {
                        if (resp.data.success === false) {
                            toast.error(resp.data.error);
                            return;
                        }
                        setSaveDisabled(true);
                        toast.success("Expense Record has been Rejected...");
                        setSelectedFinanceApproval([]);
                        setSelectedApprovedFinance([]);
                        setSelectAll(true);
                        getAllFinanceExpenseData();
                        setSelectedCategory(null);
                        setSelectedDateRange(null);
                    },
                    (err) => {
                        toast.error("There was some error while updating Expense Data...");
                    }
                );
            } catch (error) {
                toast.error("There was some error while updating Expense Data...");
            }
        } else {
            toast.warn("There was some error while updating Expense Data...");
        }
    };

    const approveTeamDialog = () => {
        return (
            <Dialog className="pop-up-dialog-recall" header="Approve Team Claim" visible={approveDialog} style={{ width: '380px' }} onHide={() => setApproveDialog(false)}>
                <ApproveExpensePopup
                    updateRejectRow={(data) => approveTeamFinanceData(data)}
                    rejectRow={approveRowData}
                    onClose={(e) => {
                        setApproveDialog(false);
                    }}
                />
            </Dialog>
        );
    };

    const approveTeamFinanceData = (data) => {
        let claimIds = selectAll ? selectedFinanceApproval.map((item) => item.claimId) : [selectedApprovedFinance.claimId];
        if (selectedApprovedFinance.status === 4 || selectedFinanceApproval.length >= 1) {
            try {
                const param = {
                    status: 6,
                    claimId: claimIds,
                    reason: data.reason,
                };
                expenseApi.updateDraftExpense(param).then(
                    (resp) => {
                        if (resp.data.success === false) {
                            toast.error(resp.data.error);
                            return;
                        }
                        setSaveDisabled(true);
                        toast.success("Expense Record has been Approved...");
                        setSelectedFinanceApproval([]);
                        getAllFinanceExpenseData();
                        setSelectAll(true);
                        setSelectedCategory(null);
                        setSelectedDateRange(null);
                    },
                    (err) => {
                        toast.error("There was some error while updating Expense Data...");
                    }
                );
            } catch (error) {
                toast.error("There was some error while updating Expense Data...");
            }
        } else {
            toast.warn("There was some error while updating Expense Data...");
        }
    };

    const checkButtonStatus = () => {
        if (selectedDateRange && selectedDateRange.length === 2) {
            setButtonStatus(true)
        }
        else if (selectCategory && selectCategory.length > 0) {
            setButtonStatus(true)
        }
        else {
            setButtonStatus(false)
            setFilterClicked(false)
            getAllFinanceExpenseData()
        }
    }

    const filterExpenseData = (e) => {
        checkButtonStatus();
        setSelectedFinanceApproval([])
        var memberList = [];
        selectCategory?.map((item, key) => {
            memberList[key] = item.id;
        })
        let param = {};
        if (memberList.length > 0) {
            param = { ...param, categories: memberList }
        }
        if (selectedDateRange && selectedDateRange.length === 2) {
            param = {
                ...param,
                startDate: moment(selectedDateRange[0]).format("YYYY-MM-DD"),
                endDate: moment(selectedDateRange[1]).format("YYYY-MM-DD"),
            }
        }
        setIsFilterActive(memberList.length > 0 || (selectedDateRange && selectedDateRange.length === 2));
        if (memberList.length > 0 || (selectedDateRange && selectedDateRange.length === 2)) {
            expenseApi.getFinanceData(param).then((resp) => {
                try {
                    setAllFinanceRecords(resp.data.data);
                } catch (error) {
                }
            });
        } else {
        }
    };

    const clearanceDateUpdate = (e) => {
        let claimIds = (Object.keys(clearanceRowData).length !== 0) ? [clearanceRowData.claimId] : selectedFinanceApproval.map((item) => item.claimId);
        if (selectedApprovedFinance.status === 6 || selectedFinanceApproval?.length >= 1) {
            if (!clearanceDate || clearanceDate.length === 0) {
                toast.warn("Please select a clearance date.");
                return;
            }
            let dateInTimeZone = new Date(clearanceDate.toLocaleString('en-US', { timeZone: timeZone }));
            try {
                let param = {
                    clearance: moment(dateInTimeZone).format('YYYY-MM-DD'),
                    claimId: claimIds,
                    status: e
                };
                expenseApi.updateDraftExpense(param).then((resp) => {
                    if (resp) {
                        setSelectedFinanceApproval([])
                        setSelectedApprovedFinance([])
                        setUpdateClearanceDialog(false)
                        setSelectAll(true)
                        toast.success("Clearance Date has been Approved Successfully..");
                        getAllFinanceExpenseData()
                        setClearanceDate([])
                        setSaveDisabled(true);
                        setSelectedCategory([]);
                        setSelectedDateRange(null);
                    }
                }, (err) => {
                    toast.error("There was some error while updating Expense ClaimData...");
                });
            } catch (error) {
                console.error("There was some error while updating Expense ClaimData...", error);
            }
        } else {
            toast.warn("Clearance date will not be update for this claim.");
        }
    };

    const changeOnCustom = (e) => {
        setSelectedDateRange(e.value)
        if (e.value[1]) {
            document.getElementsByClassName("p-datepicker")[0].style.display = "none";
        }
    }

    const updateClearanceDateDialog = () => {
        return (
            <Dialog className="pop-up-dialog" style={{ width: "600px", padding: "10px" }} header={"Update Clearance Date"} visible={updateClearanceDialog} onHide={() => setUpdateClearanceDialog(false)} >
                <Fieldset>
                    <div style={{ display: "flex", padding: "15px" }}>
                        <Calendar value={clearanceDate} rejectRow={clearanceRowData} onChange={(e) => setClearanceDate(e.value)} dateFormat="dd/mm/yy" showIcon placeholder='Select Date' showButtonBar maxDate={dateInTimeZone} />
                        <Button label="Update" className='ml-7' onClick={() => clearanceDateUpdate(9)}></Button>
                        <Button label="Cancel" className='ml-4' onClick={() => setUpdateClearanceDialog(false)}></Button>
                    </div>
                </Fieldset>
            </Dialog>
        );
    };

    const searchFinanceUserRequest = (data) => {
        setSelectedCategory([]);
        setSelectedFinanceApproval([])
        setSelectedDateRange(null);
        var dataObj = {};
        if (data?.ecn !== "") {
            dataObj.ecn = data?.ecn;
        }
        if (data?.firstName !== "") {
            dataObj.firstName = data?.firstName;
        }
        if (data?.lastName !== "") {
            dataObj.lastName = data?.lastName;
        }
        if (data?.email !== "") {
            dataObj.email = data?.email;
        }
        if (data?.claimId !== "") {
            dataObj.claimId = data?.claimId;
        }

        try {
            expenseApi.filterFinanceData(dataObj).then(
                (resp) => {
                    if (resp.status === 200) {
                        setAllFinanceRecords(resp?.data?.data)
                        setFilterDialog(false);
                        setButtonStatus(true);
                    }
                },
                (error) => {
                }
            );
        } catch (error) { }
    };

    const financeUsers = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            ecn: "",
            claimId: "",
            email: "",
        },
        onSubmit: (data) => {
            searchFinanceUserRequest(data);
            financeUsers.resetForm();
        },
    });

    const exportFinanceExcel = () => {
        const data = getAllFinanceRecords.map(record => ({
            ECN: record.ecn,
            Name: `${record.firstName} ${record.lastName}`,
            Designation: record.designation,
            'Claim ID': record.claimId,
            Category: record.category,
            BU: record.businessUnits,
            Projects: record.project.length === 0 ? 'N/A' : record.project.map(project => project.projectName).join(', '),
            Description: record.description,
            Currency: record.currency,
            'Claim Amount': record.claimAmount,
            'Clearance Date': record.clearance,
            'Submission Date': record.createdAt,
            Status: Util.fetchStatus(record.status).props.children,
        }));

        saveAs(new Blob([XLSX.write({
            SheetNames: ['Finance Records'],
            Sheets: { 'Finance Records': XLSX.utils.json_to_sheet(data) }
        }, { bookType: 'xlsx', type: 'array' })]), 'finance_records.xlsx');
    };

    const searchFinanceUsers = () => {
        return (
            <Fragment>
                <Dialog header="Finance User Filter" visible={filterDialog} position="right" modal style={{ width: '500px' }}
                    onHide={() => setFilterDialog(false)}
                    draggable={false} resizable={false}>
                    <form onSubmit={financeUsers.handleSubmit}>
                        <div className="grid p-fluid">
                            <div className="col-6 field">
                                <label htmlFor="firstName" >First Name</label>
                                <InputText name="firstName" value={financeUsers.values.firstName} onChange={financeUsers.handleChange} />
                            </div>
                            <div className="col-6 field">
                                <label htmlFor="lastName" >Last Name</label>
                                <InputText name="lastName" value={financeUsers.values.lastName} onChange={financeUsers.handleChange} />
                            </div>
                            <div className="col-6 field">
                                <label htmlFor="ecn" >ECN</label>
                                <InputText name="ecn" value={financeUsers.values.ecn} onChange={financeUsers.handleChange} />
                            </div>
                            <div className="col-6 field">
                                <label htmlFor="email" >E-Mail</label>
                                <InputText name="email" value={financeUsers.values.email} onChange={financeUsers.handleChange} />
                            </div>
                            <div className="col-6 field">
                                <label htmlFor="claimId" >Claim ID</label>
                                <InputText name="claimId" value={financeUsers.values.claimId} onChange={financeUsers.handleChange} />
                            </div>
                        </div>
                        <div className="col-12">
                            <Button type="submit" icon="pi pi-search" label="Search" className="p-button-rounded filter_btn" />
                        </div>
                    </form>
                </Dialog>
            </Fragment>
        );
    };

    return (
        <div className="tabview-demo">
            {viewEmpList && (
                <Panel>
                    <div className="formgrid grid">
                        <div className="field mr-2" style={{ width: "55px", fontWeight: "700", marginTop: "5px" }}>
                            Filter :
                        </div>
                        <div className="field mr-5" >
                            <MultiSelect options={expenseCategories} optionLabel="title" display="chip" value={selectCategory} onChange={(e) => setSelectedCategory(e.value)}
                                placeholder="Select Category" maxSelectedLabels={3} className="w-full md:w-20rem" />
                        </div>
                        <div className="field mr-4" >
                            <Calendar
                                id="range" value={selectedDateRange} onChange={(e) => changeOnCustom(e)} selectionMode="range" readOnlyInput dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="Select Period" />
                        </div>
                        <div className="field flex mr-6">
                            <Button label="Filter" style={{ marginRight: "10px", width: "100px", marginBottom: "10px" }} className="p-button-rounded" icon="pi pi-search" type="button" onClick={filterExpenseData} />
                            <Button label="Export" style={{ width: "100px", marginBottom: "8px" }} className="p-button-rounded" icon="pi pi-download" type="button" severity="secondary" onClick={exportFinanceExcel} />
                        </div>
                        <div className="field flex mr-6">
                            <Button style={{ width: "50px", marginLeft: "10px", backgroundColor: "lightcyan" }} rounded text raised severity="success" icon="pi pi-search" className="p-button-help p-button-text" aria-label="Filter" onClick={() => setFilterDialog(true)} />
                        </div>
                    </div>
                    <div className='formgrid grid mt-5'>
                        <div className="field col-6">
                            <div style={{ textAlign: "left" }}> <div className="card flex">
                                <span className="p-buttonset finance-button">
                                    <Button label="Approve All" severity="success" icon="pi pi-check" className='mr-2 mb-2' onClick={(e) => { setApproveDialog(true); setApproveRowData({}) }} disabled={!areButtonsEnabled()} />
                                    <Button label="Reject All" severity="danger" icon="pi pi-times" className='mr-2 mb-2' onClick={() => { setRejectDialog(true); setRejectRowData({}) }} disabled={!areButtonsEnabled()} />
                                    {buttonStatus && (
                                        <Button label="Update Clearance Date" severity="info" icon="pi pi-history" onClick={() => { setUpdateClearanceDialog(true); setClearanceRowData({}); }} disabled={saveDisabled || selectedFinanceApproval.length === 0} />
                                    )}
                                </span>
                            </div></div></div>
                    </div>
                    <hr />
                    <DataTable
                        paginator
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        Key="id"
                        resizableColumns
                        value={getAllFinanceRecords}
                        columnResizeMode="fit"
                        scrollable="horizontal"
                        stripedRows
                        selectionMode="checkbox"
                        selection={selectedFinanceApproval}
                        onSelectionChange={(e) => { SelectedCheckedFinanceExpenses(e.value) }}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: "2rem" }} exportable={false} ></Column>
                        <Column field="ecn" header="ECN" style={{ minWidth: '1rem' }} />
                        <Column field="firstName" header="Name" body={Util.fullNameBody} style={{ minWidth: '1rem' }} />
                        <Column field="claimId" header="Claim ID" style={{ minWidth: '1rem' }} />
                        <Column field="category" header="Category" style={{ minWidth: '1rem' }} />
                        <Column header="BU" field="businessUnits" headerStyle={{ width: "2rem" }} ></Column>
                        <Column body={Util.userProjects} header="Project" style={{ minWidth: '1rem' }} />
                        <Column field="claimAmount" header="Claim Amount" style={{ minWidth: '1rem' }} body={(rowData) => Util.renderClaimAmount(rowData)} />
                        {buttonStatus && (
                            <Column field="clearance" header="Clearance Date" style={{ minWidth: '4rem' }}></Column>
                        )}
                        <Column field="createdAt" header="Submission Date" style={{ minWidth: '4rem' }} ></Column>
                        <Column field="status" header="Status" style={{ minWidth: '1re' }} body={statusBodyTemplate} />
                        <Column field="document" header="Document" style={{ minWidth: '1rem' }} body={viewDoc} />
                        <Column header="Action" style={{ minWidth: '1rem' }} body={ReviewActionBodyTemplate} />
                    </DataTable>
                </Panel>
            )}
            {viewEmpExpenses && (
                <ExpensesReview userData={clickedViewUser} />
            )}
            {RejectExpenseDialog()}
            {carouselPopup()}
            {searchFinanceUsers()}
            {updateClearanceDateDialog()}
            {myExpenseTimeline()}
            {approveTeamDialog()}
        </div>
    )
}
export default FinanceExpenses;